import React from "react";

import { Link } from "../common/Link";
import { IFormButtonLink } from "../models/formFields.interfaces";
import { AbstractFormComponent } from "./AbstractFormComponent";

// TODO(ssr, LEVEL 2 out of 10): Migrate to functional component
// Complexity: Very simple component that renders a Link styled as a button. Only overrides
// buildContent() method. No state, lifecycle methods, or complex logic.
// Migration: Convert to functional component that uses FormFieldWrapper (created from migrated
// AbstractFormComponent). Simply render <Link> with props, wrapped in validation/error display
// component. Can become a simple functional component once AbstractFormComponent is migrated.
export class FormButtonLink extends AbstractFormComponent<
    IFormButtonLink,
    Record<string, never>
> {
    protected buildContent(): React.JSX.Element {
        return (
            <Link
                href={this.props.href}
                className="button button--inverse"
                target={this.props.target || "_top"}
            >
                {this.props.text}
            </Link>
        );
    }
}
